<template>
    <!-- 终端&商户列表 -->
    <div class="MAM_terminalList">
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="terminalForm" class="demo-form-inline">
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="terminalForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="请选择政策名称"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.terminal_sn"
                        placeholder="请输入终端SN"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="terminalForm.is_active"
                        clearable
                        placeholder="请选择激活状态"
                    >
                        <el-option label="已激活" value="1"></el-option>
                        <el-option label="未激活" value="0"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item>
					<el-select size="medium" v-model="terminalForm.terminal_type" filterable clearable style="width:100%"
						placeholder="请选择终端类型">
						<el-option label="银盛POS" value="1"></el-option>
						<el-option label="手机POS" value="2"></el-option>
						<el-option label="杉德POS" value="3"></el-option>
						<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
					</el-select>
				</el-form-item>
 <!--               <el-form-item>
                    <el-select
                        size="medium"
                        v-model="terminalForm.class_type"
                        clearable
                        placeholder="请选择商户分类"
                    >
                        <el-option label="优质商户" value="1"></el-option>
                        <el-option label="活跃商户" value="2"></el-option>
                        <el-option label="沉默商户" value="3"></el-option>
                        <el-option label="新增商户" value="4"></el-option>
                        <el-option label="未激活商户" value="5"></el-option>
                    </el-select>
                </el-form-item> -->
<!--                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="terminalForm.merchant_type"
                        clearable
                        placeholder="请选择商户类型"
                    >
                        <el-option label="个人商户" value="1"></el-option>
                        <el-option label="企业商户" value="2"></el-option>
                        <el-option label="小微商户" value="3"></el-option>
                    </el-select>
                </el-form-item> -->
                <el-form-item>
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.merchant_number"
                        placeholder="请输入商户编号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.name"
                        placeholder="请输入商户名称"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.tel"
                        placeholder="请输入商户手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0 || level == 1">
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.phone"
                        placeholder="请输入终端归属代理账号"
                    ></el-input>
                </el-form-item>
                <el-form-item v-if="level == 0 || level == 1">
                    <el-input
                        size="medium"
                        clearable
                        v-model="terminalForm.real_name"
                        placeholder="请输入终端归属代理姓名"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="创建开始日期"
                        end-placeholder="创建结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(terminalForm)"
                    >查询</el-button>
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-download"
                    :loading="downLoading"
                    @click="handleDownLoad(terminalForm)"
                          v-if="user_level <=1"
                  >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="terminalTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- id -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 终端类型 -->
                <!-- <el-table-column
                        header-align="center"
                        align="center"
                        prop="agent_name"
                        label="主机构名称"
                        min-width="150"
                        v-if="user_level == 0"
                ></el-table-column> -->
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="政策名称"
                    min-width="150"
                ></el-table-column>
                <!-- 终端SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="终端SN"
                    min-width="200"
                ></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_channel" label="终端类型"
					min-width="100"></el-table-column>
                <!-- 激活状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="is_active"
                    label="激活状态"
                    min-width="100"
                >
                    <template slot-scope="scope">{{scope.row.is_active == 1? '已激活': '未激活'}}</template>
                </el-table-column>
                <!-- 商户编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_number"
                    label="商户编号"
                    min-width="130"
                ></el-table-column>
                <!-- 商户名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="name"
                    label="商户名称"
                    min-width="150"
                ></el-table-column>
                <!-- 商户手机号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="tel"
                    label="商户手机号"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.tel | desMobile" placement="top">
                      <p>{{ scope.row.tel | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 商户分类 -->
<!--                <el-table-column-->
<!--                    header-align="center"-->
<!--                    align="center"-->
<!--                    prop="type"-->
<!--                    label="商户分类"-->
<!--                    min-width="100"-->
<!--                    :formatter="handleMerchantType"-->
<!--                ></el-table-column>-->
                <!-- 商户备注手机号 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="tel"
                    label="商户备注手机号"
                    min-width="120"
                ></el-table-column>-->
                <!-- 终端归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    :label="level > 1 ? '终端所属团队账号' : '终端归属代理账号'"
                    min-width="120"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.phone | desMobile" placement="top">
                      <p>{{ scope.row.phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 终端归属代理编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    :label="level > 1 ? '终端所属团队编号' : '终端归属代理编号'"
                    min-width="150"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.agent_no" placement="top">
                      <p>{{ scope.row.agent_no | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 终端归属代理姓名 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    :label="level > 1 ? '终端所属团队姓名' : '终端归属代理姓名'"
                    min-width="150"
                ></el-table-column>
                <!-- 终端归属代理昵称 -->
<!--                <el-table-column-->
<!--                    header-align="center"-->
<!--                    align="center"-->
<!--                    prop="u_nickname"-->
<!--                    :label="level > 1 ? '终端所属团队昵称' : '终端归属代理昵称'"-->
<!--                    min-width="150"-->
<!--                ></el-table-column>-->
                <!-- 激活时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="active_time"
                    label="激活时间"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.is_active == 1">{{scope.row.active_time}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <!-- 商户创建时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="商户创建时间"
                    min-width="150"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small">详情</el-button>
                        <!-- <el-button v-if="scope.row.is_active == 1 || scope.row.transaction_number !== null || scope.row.pay_type !== null" type="text" size="small" @click="unbindingClick(scope.row)"><span style="color: #60617A;">强制解绑</span></el-button> -->
                        <!-- <el-button v-else @click="handleunbindInfo(scope.row)" type="text" size="small">解绑</el-button> -->
                        <template v-if="scope.row.terminal_type != null && scope.row.terminal_type == 1">
                            <el-button v-if="user_level == 0 && scope.row.terminal_type != 2 && scope.row.terminal_type != null" @click="showUnBindBtn(scope.row)"  type="text" size="small">强制解绑</el-button>
                        </template>
                        <template v-else>
                            <el-button v-if="user_level == 0 && scope.row.terminal_type != 2 && scope.row.terminal_type != null" @click="showUnBindBtn(scope.row)"  type="text" size="small">强制解绑</el-button>
                        </template>
                        
                        <!-- <el-button v-if="user_level == 0" @click="showUnBindInfo(scope.row)"  type="text" size="small">换绑解绑记录</el-button> -->
                        <!-- <el-button v-if="user_level >1 && scope.row.is_active == 1 && scope.row.terminal_type == 1" @click="showApplyUnBindInfo(scope.row)"  type="text" size="small">申请强制解绑</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <terminal-info v-if="detail.isShow" :detail="detail" @infoClose="infoClose"></terminal-info>
		<!-- 申请换绑操作 -->
		<div class="show_un_bind_info" v-if="apply_un_bind_show" >
		     <el-card class="box-card">
		         <div slot="header" class="clearfix hide_bind_info">
		             <i class="el-icon-close" @click="closeApplyUnBindInfo()"></i>
		         </div>
		         <div style="font-size:15px">解绑原因</div>
		         <el-form ref="form" style="margin-top:20px">
		             <el-form-item>
		                 <el-input type="textarea" :rows="5" v-model="un_remark"></el-input>
		             </el-form-item>
							<el-form-item style="text-align: center;">
							    <el-button
							        size="medium"
							        type="primary"
							        style="font-size: 12px;"
							        @click="sub_apply_un_bind()"
							    >提交换绑申请</el-button>
							</el-form-item>
		         </el-form>
		     </el-card>
		 </div>
        <div class="show_un_bind_info" v-if="show_un_bind_info">
            <el-card class="box-card">
                <div slot="header" class="clearfix hide_bind_info">
                    <i class="el-icon-close" @click="showUnBindInfo()"></i>
                </div>
                <el-table :data="un_bind_list" border style="width: 100%;font-size:12px">
                    <el-table-column prop="nickname" width="130" header-align="center" align="center" label="申请人" fixed></el-table-column>
                    <el-table-column prop="terminal_sn" width="190" header-align="center" align="center" label="申请终端sn"></el-table-column>
                    <el-table-column prop="terminal_sn_new" width="190" header-align="center" align="center" label="替换终端sn"></el-table-column>
                    <el-table-column prop="create_time" width="150" header-align="center" align="center" label="申请时间"></el-table-column>
                    <el-table-column prop="type" header-align="center" align="center" label="类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.type == 1">强制解绑</span>
                            <span v-if="scope.row.type == 2">换绑</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="status" header-align="center" align="center" label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 0">未审核</span>
                            <span v-if="scope.row.status == 1">已同意</span>
                            <span v-if="scope.row.status == 2">不同意</span>
                        </template>
                    </el-table-column>

                    <el-table-column prop="update_time" width="150" header-align="center" align="center" label="同意或拒绝时间"></el-table-column>
                    <el-table-column prop="remark" width="230" header-align="center" align="center" label="备注" ></el-table-column>
                    <el-table-column fixed="right" header-align="center" align="center" label="操作" width="100">
                        <template slot-scope="scope" v-if="(user_level == 1 || user_level == 0) && scope.row.type == 2 && scope.row.status == 0">
                            <el-button type="text" @click="changeUnBindSn(scope.row)" size="small">同意换绑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="check_page">
                    <el-pagination @current-change="nextPage" background layout="prev, pager, next" :total="un_bind_list_count"></el-pagination>
                </div>

            </el-card>
        </div> 

        <div class="show_un_bind_info" v-if="show_un_bind_btn" >
            <el-card class="box-card" style="width:25%">
                <div slot="header" class="clearfix hide_bind_info">
                    <i class="el-icon-close" @click="show_un_bind_btn = false"></i>
                </div>
                <div>解绑原因</div>
                <el-form ref="form" style="margin-top:20px">
                    <el-form-item>
                        <el-input type="textarea" :rows="5" v-model="remark"></el-input>
                    </el-form-item>
                </el-form>
                <div class="un_bind_info_btn">
                    <button type="button" @click="forceUnBindInfo" class="el-button el-button--small"><span>强制解绑</span></button>
                </div>

            </el-card>
        </div> 
		
		
		<el-dialog title="解绑终端" :visible.sync="showSdJieBund" class="dialog">
		  <el-form ref="addForm" label-width="120px">
			  
			  <el-form-item label="解绑验证码:">
				  <el-col :span="18">
				  	<el-input placeholder="请输入验证码"  v-model="sdCode" autocomplete="off"></el-input>
				  </el-col>
				  <el-col :span="6">
				  	<el-button :style="{'color':codeState==true?'#999999':'#FF8532', 'border-color':codeState==true?'#999999':'#FF8532','margin-left':'10px','font-size': '12px'}"  size="medium" 
				  		@click="codeClick">{{codeState==true?seconds + 's':'发送'}}</el-button>
				  </el-col>
			    
			  </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="showSdJieBund = false">取 消</el-button>
		    <el-button type="primary" @click="jieSdSubmit">确 定</el-button>
		  </div>
		</el-dialog>


    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
import terminalInfo from './MAM_terminalInfo';
export default {
    name: "MAM_terminalList",
    data() {
        return {
            brandList: [],
            parm:{},
            detail: {
                isShow: false
            },
            terminalTable: [], //表格
            terminalForm: {
                brand_id: '', //终端类型id
                terminal_sn: '', //终端sn
                terminal_number: '', //终端编号
                is_active: '', //是否激活 1.已激活 0.未激活
				terminal_type:'',
                merchant_number: '', //商户编号
                name: '',    //商户名称
                tel: '',    //商户手机号
                phone: '',    //终端归属代理账号
                real_name: '',    //终端归属代理名称
                class_type: '', //商户分类 1.优质 2.活跃 3.沉默 4.新增 5.未激活
                start_time: '',
                end_time: '',
                page: 1,
                limit: 10,
            },
            rangeDate:[],
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level') || 0,
            user_level : sessionStorage.getItem('level') ? sessionStorage.getItem('level') : null,
			apply_un_bind_show:false,//提交换绑申请页面
			un_remark:'',//换绑原因
			apply_un_bind_info:"",//当前选择信息
            show_un_bind_info:false,//换绑界面显示
            un_bind_list: [],//换绑终端数据
            un_bind_list_count : 0,//换绑终端数据数量
            un_bind_list_page:1,//换绑列表页数
            show_un_bind_btn:false,//换绑按钮
            un_bind_info:'',//换绑数据
            remark:'',//解绑原因


            
            apply_un_bind_info_page:1,//展示换绑列表页数
            apply_un_bind_info_list:[],//展示换绑列表数据
            apply_un_bind_info_count:0,
			showSdJieBund:false,
			sdCode:'',
			codeState: false,
			seconds: 180,

        }
    },
    mounted() {
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$$message.success(res.msg);
            }
        });
        this.getData( //初始化
            {
                page: 1,
                limit: this.page.pageSize
            }
        );

    },
    components: {
        paginations,
        terminalInfo
    },
    methods: {
		//强制解绑
		unbindingClick(row){
			let _this = this;
			this.$confirm('强制解绑不可恢复，确认强制解绑该终端?', '提示', {
			    confirmButtonText: '确认',
			    cancelButtonText: '取消',
			    closeOnClickModal: false,
			    type: 'warning',
			    beforeClose: (action, instance, done) => {
			        if (action == 'confirm') {
			            _this.$api.post("merchant/forceTerminalUnbind", {merchant_channel_id:row.merchant_channel_id}, res => {
			            	if (res.code == 0) {
			            	    _this.$message({
			            	        type: 'success',
			            	        message: res.msg,
			            	        duration: 1500,
			            	        onClose() {
			            				  _this.getData( //初始化
			            				    {
			            				        page: 1,
			            				        limit: _this.page.pageSize
			            				    }
			            				);
			            	        }
			            	    })
								      done();
			            	} else {
			            	    this.$message.error(res.msg);
                        done();
			            	}
			            })
			        } else {
			            done();
			        }
			    }
			}).then(() => {
			}).catch(() => { });
			
		},
        handleSearch(terminalForm) {
            this.terminalForm.page = 1;
            this.page.currentPage = 1; //重置分页
            // 表单提交
            this.getData(terminalForm);
        },
        handleInfo(row) { //详情
            this.detail.isShow = true;
            this.detail.info = row;
        },
        handleunbindInfo(row) { //解绑终端
            var _this = this;
            this.$confirm('确认解绑该终端?', '提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning',
                beforeClose: (action, instance, done) => {
                    if (action == 'confirm') {
                        instance.confirmButtonLoading = true;
                        _this.parm.merchant_id=row.id;
                        _this.parm.brand_id=row.brand_id;
                        _this.parm.merchant_number=row.merchant_number;
                        _this.parm.merchant_type=row.merchant_type;
                        _this.parm.terminal_id=row.terminal_id;
                        _this.parm.terminal_number=row.terminal_number;
                        _this.parm.terminal_sn=row.terminal_sn;
                        _this.parm.user_id=row.user_id;
                        _this.parm.mf_id=row.mf_id;
                        _this.$api.post('merchant/unbindterminal', _this.parm, res => {
                            if (res.code == 0) {
                                instance.confirmButtonLoading = false;
                                this.$message.success(res.msg);
                                this.loading = true;
                                this.getData({
                                    page: this.page.currentPage,
                                    limit: this.page.pageSize,
                                });
                                done();

                            } else {
                                this.$message.error(res.msg);
                                instance.confirmButtonLoading = false;
                            }
                        })
                    } else {
                        instance.confirmButtonLoading = false;
                        done();
                    }
                }
            }).then(() => {
            }).catch(() => { });
        },
        infoClose() { //关闭弹窗
            this.detail.isShow = false;
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.terminalForm.page = this.page.currentPage;
            this.terminalForm.limit = this.page.pageSize;
            this.getData(this.terminalForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.terminalForm.page = this.page.currentPage;
            this.terminalForm.limit = limit;
            this.getData(this.terminalForm);
        },
        pickerChange(DateArr) { //时间选择器
            this.terminalForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.terminalForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
        },
        getData(params) {
            this.$api.post("merchant/getList", params, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.terminalTable = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleDownLoad(params) { //导出
          // this.downLoading = true;
          // this.$api.post("merchant/getListDownload", params, res => {
           //  if (res.code == 0) {
            //   this.$message.success(res.msg);
            //   var link=this.$file_url+res.data;
            //   window.open(link)
           //  } else {
            //   this.$message.error(res.msg);
           //  }
           //  //渲染结束后取消加载
           //  this.downLoading = false;
          // })
      
			  let reqData = {
				  type: 6,
				  value: JSON.stringify(params)
			  };
			  
			  this.downLoading = true; 
			  this.$api.post('export/add', reqData, res => {
				  if (res.code == 0) {
					  this.$message.success(res.msg);
				  this.downLoading = false;
				  } else {
					  this.$message.error(res.msg);
				  this.downLoading = false;
				  }
			  
			  })
        },
        handleMerchantType(row) {
            let type;
            switch (row.type) {
                case 1:
                    type = '优质商户';
                    break;
                case 2:
                    type = '活跃商户';
                    break;
                case 3:
                    type = '沉默商户';
                    break;
                case 4:
                    type = '新增商户';
                    break;
                case 5:
                    type = '未激活商户';
                    break;
            }
            return type;
        },
		//弹出申请换绑
		showApplyUnBindInfo(data){
			console.log(data)
			this.apply_un_bind_show=true;
		    this.apply_un_bind_info = data;
		    // this.show_apply_un_bind_info ==  true ? this.show_apply_un_bind_info = false : this.show_apply_un_bind_info = true
		    // if(this.show_apply_un_bind_info ==  false){return false;}
		    // this.getApplyUnBindInfoList()
		},
		//关闭申请换绑
		closeApplyUnBindInfo(){
			this.apply_un_bind_show=false;
		},
		sub_apply_un_bind(){
		    var obj = {data:this.apply_un_bind_info,remark:this.un_remark}
		    this.$api.post("terminal/subApplyUnBind", obj, res => {
		        if (res.code == 0) {
		            // this.showApplyUnBindInfo()//加载数据
		            this.$message.success(res.msg);
					this.apply_un_bind_show=false;
		        }else{
		            this.$message.error(res.msg);
		        }
		    })
		},
		
        //解绑操作
        showUnBindBtn(data = ''){
			//解绑之前 查询 是否有交易 未结算金额等情况
			this.un_bind_info = data;
			if (data.terminal_type == 1) {
				this.$api.post("merchant/get_merchant_transaction", {merchant_channel_id:this.un_bind_info.merchant_channel_id}, res => {
				    if (res.code == 0) {
						if(res.data.is_transaction == 1){
							this.$confirm('当前商户/终端有交易，请谨慎解绑', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
								this.forceUnBindInfo()
							}).catch(err=>{});
						}else if(res.data.is_account_balance == 1){
							this.$confirm('当前商户有未结算金额，暂不可解绑', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton:false}).then(()=>{
								// this.forceUnBindInfo()
							}).catch(err=>{});
						}else{
							this.$confirm('确定解绑该终端', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
								this.forceUnBindInfo()
							}).catch(err=>{});
						}
				    }else{
						this.$message.error(res.msg);
					}
				})
			}
			
			// 杉德
			if (data.terminal_type == 3) {
				this.showSdJieBund = true
			}
			// 联动
			if (data.terminal_type == 4) {
				this.$confirm('确定解绑该终端', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
					let obj = {merchant_channel_id:this.un_bind_info.merchant_channel_id,terminal_type:4}
					   this.show_un_bind_btn == false;
					   this.$api.post("merchant/forceTerminalUnbind", obj, res => {
						   if (res.code == 0) {
							   this.$message.success(res.msg);
							   this.getData({
							       page: this.page.currentPage,
							       limit: this.page.pageSize,
							   });
						   }else if(res.code == 100001){
							   this.$confirm('当前商户/终端有交易，暂不可解绑', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton:false}).then(()=>{
							   }).catch(err=>{});
							   
						   }else {
							   this.$message.error(res.msg);
						   }
					   })
					
					
				}).catch(err=>{});
				
				
				
			}
            
            // 海科
            if (data.terminal_type == 5) {
            	this.$confirm('确定解绑该终端', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
            		let obj = {merchant_channel_id:this.un_bind_info.merchant_channel_id,terminal_type:5,merchant_type:this.un_bind_info.merchant_type}
            		   this.show_un_bind_btn == false;
            		   this.$api.post("merchant/forceTerminalUnbind", obj, res => {
            			   if (res.code == 0) {
            				   this.$message.success(res.msg);
            				   this.getData({
            				       page: this.page.currentPage,
            				       limit: this.page.pageSize,
            				   });
            			   }else if(res.code == 100001){
            				   this.$confirm('当前商户/终端有交易，暂不可解绑', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton:false}).then(()=>{
            				   }).catch(err=>{});
            				   
            			   }else {
            				   this.$message.error(res.msg);
            			   }
            		   })
            		
            		
            	}).catch(err=>{});
            	
            	
            	
            }
            if (data.terminal_type == 6) {
				this.$confirm('确定解绑该终端', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(()=>{
            		let obj = {merchant_channel_id:this.un_bind_info.merchant_channel_id,terminal_type:6,merchant_type:this.un_bind_info.merchant_type}
            		   this.show_un_bind_btn == false;
            		   this.$api.post("merchant/forceTerminalUnbind", obj, res => {
            			   if (res.code == 0) {
            				   this.$message.success(res.msg);
            				   this.getData({
            				       page: this.page.currentPage,
            				       limit: this.page.pageSize,
            				   });
            			   }else if(res.code == 100001){
            				   this.$confirm('当前商户/终端有交易，暂不可解绑', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning',showCancelButton:false}).then(()=>{
            				   }).catch(err=>{});
            				   
            			   }else {
            				   this.$message.error(res.msg);
            			   }
            		   })
            		
            		
            	}).catch(err=>{});
            	
			}
			
            // this.show_un_bind_btn == true ? this.show_un_bind_btn = false : this.show_un_bind_btn = true
			this.remark = '';
        },
		// 杉德发送验证码
		codeClick(){
			if (this.codeState) {
				return
			}
			this.$api.post("sd_terminal/sendSdMms", {sn:this.un_bind_info.terminal_sn}, res => {
			    if (res.code == 0) {
					this.$message({
					    message: '发送成功',
						type:'success'
					});
					this.codeState = true;
					 const number =	setInterval((res)=>{
						let second = this.seconds - 1;
						this.seconds = second;
						if(second == 0){
						     clearInterval(number)
							 this.seconds = 180;
							 this.codeState = false;
						 }
					  },1000)
			    }else{
					this.$message.error(res.msg);
				}
			})
		},
		// 杉德解绑
		jieSdSubmit(){
			
			if (this.sdCode.length == 0) {
				this.$message.error('请输入验证码');
				return false;
			}
			
			let obj = {
				merchant_channel_id:this.un_bind_info.merchant_channel_id,
				terminal_type:3,
				sd_sms_code:this.sdCode
				}
			   this.show_un_bind_btn == false;
			   this.$api.post("merchant/forceTerminalUnbind", obj, res => {
				   if (res.code == 0) {
					   this.showSdJieBund = false
					   this.$message.success(res.msg);
					   this.getData({
					       page: this.page.currentPage,
					       limit: this.page.pageSize,
					   });
				   }else{
					   this.$message.error(res.msg);
				   }
			   })
		},
        //强制解绑 只有admin用户才可用
        forceUnBindInfo(){
            let obj = {
                merchant_channel_id:this.un_bind_info.merchant_channel_id,
                terminal_type:1,
                merchant_type:this.un_bind_info.merchant_type}
			   this.show_un_bind_btn == false;
			   this.$api.post("merchant/forceTerminalUnbind", obj, res => {
				   if (res.code == 0) {
					   this.$message.success(res.msg);
					   this.getData({
					       page: this.page.currentPage,
					       limit: this.page.pageSize,
					   });
				   }else{
					   this.$message.error(res.msg);
				   }
			   })
        },

        //显示换绑列表弹框
        showUnBindInfo(data = ''){
            this.un_bind_info = data
            this.show_un_bind_info == true ? this.show_un_bind_info = false : this.show_un_bind_info = true
            this.un_bind_list_page = 1;
            if(this.show_un_bind_info == true){
                this.getUnbindList()
            }
        },
        // 下一页
        nextPage(page){
            this.un_bind_list_page = page
            this.getUnbindList()
        },
        //获取换绑列表
        getUnbindList(){
            this.$api.post("merchant/forceTerminalUnbindList", {merchant_channel_id:this.un_bind_info.merchant_channel_id,page:this.un_bind_list_page}, res => {
                if(res.code == 0){
                    this.un_bind_list = res.data.data
                }
            })
        },
        //同意换绑操作
        changeUnBindSn(data){
            if((parseInt(this.user_level) == 1 || parseInt(this.user_level) == 0) && data.type == 2){
                if(data.status != 0){
                    this.$message.error('不可重复操作');
                    // return false;
                }
                this.$api.post("terminal/changeUnBindSn", {main_id:data.id}, res => {
                    if (res.code == 0) {
                        this.getUnbindList()//加载数据
                        this.$message.success(res.msg);
                    }else{
                        this.$message.error(res.msg);
                    }
                })
            }else{
                this.$message.error('权限不够');return false;
            }
        },
        //申请列表下一页
        applyUnBindNextPage(data){
            this.apply_un_bind_info_page = data
            this.getApplyUnBindInfoList()
        },
        //可申请切换列表
        getApplyUnBindInfoList(){
            this.$api.post("terminal/getApplyUnBindInfoList", {brand_id:this.apply_un_bind_info.brand_id,mf_id:this.apply_un_bind_info.mf_id,page:this.apply_un_bind_info_page}, res => {
                if(res.code == 0){
                    this.apply_un_bind_info_list = res.data.data
                    this.apply_un_bind_info_count = res.data.count
                }
            })
        },

    }
};
</script>

<style lang="scss" scoped>
    .show_un_bind_info{position:fixed;top:0;display:flex;justify-content:center;align-items:center;background-color:rgba(0,0,0,0.5);height:100%;
        width:100%;z-index:100;left:0}
    .show_un_bind_info .box-card{width:60%;}
    .hide_bind_info{display:flex;justify-content:flex-end}
    .check_page{display:flex;justify-content:center;padding-top:20px}
    .un_bind_info_btn{display:flex;justify-content:center;align-items: center;margin-top:20px;}
</style>
